import { Form, InputNumber } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { useEffect } from 'react';
import { getMidasAccountInfo, setBalanceWarn } from '../../../../../api';
import { ConsoleDrawer } from '../../../../../components/drawer';
import { ConsoleForm } from '../../../../../components/form';
import { CommonPrompt } from '../../../../../components/prompt';
import { CommonSelect } from '../../../../../components/select';
import getFormatMessage from '../../../../../locales/get-format-message';
import {
  IAPIStudioMemberHasPermissionItem,
  RoleType,
} from '../../../../../model/api-modules';

interface IProps {
  onClose?: () => void;
  readonly studioId: string;
  readonly members: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
}

interface IWarnFormInfo {
  threshold: number;
  emails: string[];
}

export const BalanceWarnDrawer = (props: IProps) => {
  const { members, onClose, studioId } = props;

  const [form] = useForm<IWarnFormInfo>();
  const memberOptions = members.map((item) => {
    return { label: `${item.UserName}(${item.UserID})`, value: item.UserID };
  });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const accountInfo = await getMidasAccountInfo(studioId);
    if (accountInfo?.alarm_receiver === 'owner') {
      const owner = members.find((item) =>
        item.RbacMember?.some((member) => member.roleType === RoleType.Owner)
      );
      if (!owner) {
        return;
      }
      form.setFieldsValue({
        threshold: Number(accountInfo?.alarm_balance) || 0,
        emails: [owner.UserID],
      });
      return;
    }
    form.setFieldsValue({
      threshold: Number(accountInfo?.alarm_balance) || 0,
      emails: accountInfo?.alarm_receiver?.split(',') || [],
    });
  };

  const submit = async () => {
    const data = await form.validateFields();
    const owner = members.find((item) =>
      item.RbacMember?.some((member) => member.roleType === RoleType.Owner)
    );

    const isOwner = data.emails.join('') === owner?.UserID;
    await setBalanceWarn({
      studio_id: studioId,
      alarm_balance: data.threshold,
      alarm_receiver: isOwner ? 'owner' : data.emails.join(),
    });
    onClose?.();
    return true;
  };

  return (
    <ConsoleDrawer
      title={getFormatMessage('title_balance')}
      onClose={props.onClose}
      onOk={submit}
    >
      <>
        <CommonPrompt style={{ marginBottom: 20 }}>
          <span>
            {getFormatMessage('when_available_balance_less_than_threshold')}
          </span>
        </CommonPrompt>
        <ConsoleForm form={form}>
          <Form.Item
            label={getFormatMessage('warning_threshold')}
            name="threshold"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber prefix={'¥'} />
          </Form.Item>
          <Form.Item
            label={getFormatMessage('notification_scope')}
            name="emails"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <CommonSelect
              mode="multiple"
              options={memberOptions}
              maxCount={10}
            />
          </Form.Item>
        </ConsoleForm>
      </>
    </ConsoleDrawer>
  );
};
